export { default } from './SWIncludesCard';
